import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { GroupListService } from '../../service/group-list/group-list.service';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  providers: [
    GroupListService,
    HttpModule
  ]
})

export class GroupListComponent implements OnInit {

  private token;
  public groups: any[] = [];
  public groupsSeach: any[];
  public resultCount: number = 0;
  public orderby: string = "Nome";
  public sort: string = "asc";
  public permissoes: any[] = [];
  currentPage: number = 0;
  groupUser: FormGroup;

	constructor(fb: FormBuilder, private groupListService: GroupListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.groupUser = fb.group({
			'Nome': '',
			'Ativo': 'true'
		});
	}
  
	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchGroup(this.groupUser.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchGroup(this.groupUser.value, this.currentPage, false);
	}

	searchGroup(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.groupListService.searchUser(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.groups = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchGroup(this.groupUser.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/group/component/group-list/group-list.component.ts